module.exports = __webpack_public_path__ + "static/newbabyletterboxmain-f9d7084146438db9a708a8757cab5164.png";